import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  CheckbookNumberChanged,
  ClearGenerateCheckbookFilters,
  GenerateCheckbooks,
  GenerateCheckbooksFailure,
  GenerateCheckbooksSuccess,
  GetBookCouponGroupsTemplatesSuccess,
  SelectedBookCouponGroupTempIdChanged,
  SubmitGenerateCheckbookData,
  ValidFromDateChanged,
  ValidFromDateCleared,
  ValidUntilDateChanged,
  ValidUntilDateCleared,
} from '../actions/generate-checkbook.actions';

export interface GenerateCheckbookState {
  generateCheckbookTypes: { code: string; bookCouponGroupTemplateId: number }[];
  bookCouponGroupTempId: number | null;
  checkbookNumber: string;
  isSubmittedData: boolean;
  validFromDate: Date | null;
  validFromDateFormat: string;
  validUntilDate: Date | null;
  validUntilDateFormat: string;
  showBtnSpinner: boolean;
}

const initialState: GenerateCheckbookState = {
  generateCheckbookTypes: [],
  bookCouponGroupTempId: null,
  checkbookNumber: '',
  isSubmittedData: false,
  validFromDate: null,
  validFromDateFormat: '',
  validUntilDate: null,
  validUntilDateFormat: '',
  showBtnSpinner: false,
};

export const GenerateCheckbookReducer = createReducer(
  initialState,
  on(GetBookCouponGroupsTemplatesSuccess, (state, { response }) => ({
    ...state,
    generateCheckbookTypes: response.map((x) => ({
      code: x.code,
      bookCouponGroupTemplateId: x.bookCouponGroupTemplateId,
    })),
  })),
  on(SelectedBookCouponGroupTempIdChanged, (state, { bookCouponGroupTempId }) => ({
    ...state,
    bookCouponGroupTempId,
  })),
  on(CheckbookNumberChanged, (state, { checkbookNumber }) => ({
    ...state,
    checkbookNumber,
  })),
  on(SubmitGenerateCheckbookData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
  on(ValidFromDateChanged, (state, { validFromDate, validFromDateFormat }) => ({
    ...state,
    validFromDate,
    validFromDateFormat,
  })),
  on(ValidFromDateCleared, (state) => ({
    ...state,
    validFromDate: null,
    validFromDateFormat: '',
  })),
  on(ValidUntilDateChanged, (state, { validUntilDate, validUntilDateFormat }) => ({
    ...state,
    validUntilDate,
    validUntilDateFormat,
  })),
  on(ValidUntilDateCleared, (state) => ({
    ...state,
    validUntilDate: null,
    validUntilDateFormat: '',
  })),
  on(ClearGenerateCheckbookFilters, (state) => ({
    ...state,
    bookCouponGroupTempId: null,
    checkbookNumber: '',
    isSubmittedData: false,
    validFromDate: null,
    validFromDateFormat: '',
    validUntilDate: null,
    validUntilDateFormat: '',
    showBtnSpinner: false,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    bookCouponGroupTempId: null,
    checkbookNumber: '',
    isSubmittedData: false,
    validFromDate: null,
    validFromDateFormat: '',
    validUntilDate: null,
    validUntilDateFormat: '',
    showBtnSpinner: false,
  })),
  on(GenerateCheckbooks, (state) => ({
    ...state,
    showBtnSpinner: true,
  })),
  on(GenerateCheckbooksSuccess, (state) => ({
    ...state,
    showBtnSpinner: false,
  })),
  on(GenerateCheckbooksFailure, (state) => ({
    ...state,
    showBtnSpinner: false,
  })),
);
